import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { Storage } from "aws-amplify";
import "./ServicesSection.css";

const SERVICE_S3_KEYS = [
  "portfolio/steps/steps_lg00015.jpeg",
  "portfolio/pavers/pavers00001.jpeg",
  "portfolio/concrete/concrete_lg_00008.jpeg",
  "portfolio/retaining/retaininig_lg00006.jpeg",
];

const services = [
  {
    id: 1,
    title: "BRICK STEPS",
    subtitle: "Entryway Excellence",
    description: "Custom brick steps that combine durability with timeless elegance. Our master masons craft each step with precision, using traditional Polish techniques passed down through generations.",
    s3Key: SERVICE_S3_KEYS[0],
    features: ["Custom Design", "30+ Year Durability", "Weather Resistant"]
  },
  {
    id: 2,
    title: "PAVERS",
    subtitle: "Patios & Driveways",
    description: "Transform your outdoor spaces with expertly installed pavers. From elegant patios to stunning driveways, we create surfaces that endure and impress.",
    s3Key: SERVICE_S3_KEYS[1],
    features: ["Premium Materials", "Perfect Grading", "Lifetime Warranty"]
  },
  {
    id: 3,
    title: "CONCRETE",
    subtitle: "Foundation of Quality",
    description: "Precision concrete work for residential and commercial projects. Sidewalks, foundations, decorative concrete—we deliver strength and beauty in every pour.",
    s3Key: SERVICE_S3_KEYS[2],
    features: ["Stamped Options", "Reinforced", "Crack Resistant"]
  },
  {
    id: 4,
    title: "RETAINING WALLS",
    subtitle: "Structural Artistry",
    description: "Functional retaining walls that double as landscape features. We engineer solutions that prevent erosion while enhancing your property's aesthetic appeal.",
    s3Key: SERVICE_S3_KEYS[3],
    features: ["Expert Engineering", "Natural Stone", "Drainage Systems"]
  }
];

export default function ServicesSection() {
  const [visibleCards, setVisibleCards] = useState([]);
  const [imageUrls, setImageUrls] = useState({});
  const sectionRef = useRef(null);

  useEffect(() => {
    Promise.all(
      SERVICE_S3_KEYS.map(async (key) => {
        try {
          return [key, await Storage.get(key)];
        } catch { return [key, null]; }
      })
    ).then((entries) => setImageUrls(Object.fromEntries(entries)));
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const id = parseInt(entry.target.dataset.id);
            setVisibleCards((prev) => [...new Set([...prev, id])]);
          }
        });
      },
      { threshold: 0.2 }
    );

    const cards = document.querySelectorAll(".service-card");
    cards.forEach((card) => observer.observe(card));

    return () => observer.disconnect();
  }, []);

  return (
    <section className="services-section" ref={sectionRef}>
      {/* Background Elements */}
      <div className="services-bg">
        <div className="grid-pattern"></div>
      </div>

      <div className="services-container">
        {/* Header */}
        <div className="services-header">
          <span className="section-label">WHAT WE DO</span>
          <h2 className="section-title">
            MASTER <span className="gold-text">CRAFTSMANSHIP</span>
            <br />IN EVERY PROJECT
          </h2>
          <p className="section-description">
            Four decades of perfecting our craft. We bring old-world Polish masonry 
            techniques to modern construction, delivering results that stand the test of time.
          </p>
        </div>

        {/* Services Grid */}
        <div className="services-grid">
          {services.map((service, index) => (
            <div
              key={service.id}
              data-id={service.id}
              className={`service-card ${visibleCards.includes(service.id) ? "visible" : ""}`}
              style={{ animationDelay: `${index * 0.15}s` }}
            >
              <div className="card-image-container">
                {imageUrls[service.s3Key] && <img src={imageUrls[service.s3Key]} alt={service.title} className="card-image" />}
                <div className="card-image-overlay"></div>
                <span className="card-number">0{service.id}</span>
              </div>
              <div className="card-content">
                <span className="card-subtitle">{service.subtitle}</span>
                <h3 className="card-title">{service.title}</h3>
                <p className="card-description">{service.description}</p>
                <div className="card-features">
                  {service.features.map((feature, i) => (
                    <span key={i} className="feature-tag">{feature}</span>
                  ))}
                </div>
                <Link to="/portfolio" className="card-link">
                  View Projects
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M5 12h14M12 5l7 7-7 7"/>
                  </svg>
                </Link>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}
